import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { PlayButton } from "./PlayButton";
import { RevealLine } from "./RevealLine";

export const FinalCta = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const rot = useTransform(scrollYProgress, [0, 1], [-40, 40]);

  return (
    <section ref={ref} className="relative overflow-hidden px-5 py-28 sm:px-8 lg:px-12 lg:py-40" data-testid="final-cta-section">
      <motion.img src="/assets/roobet-icon.png" alt="" style={{ rotate: rot }} className="pointer-events-none absolute -right-24 top-1/2 h-[420px] w-[420px] -translate-y-1/2 opacity-15 sm:h-[560px] sm:w-[560px]" />
      <div className="relative mx-auto max-w-7xl">
        <img src="/assets/roobet-logo.webp" alt="Roobet" className="h-8 w-auto sm:h-10" data-testid="final-cta-roobet-logo" />
        <h2 className="section-title mt-8 font-display text-white">
          <RevealLine>Your seat at</RevealLine>
          <RevealLine delay={0.1}>the table is <span className="text-[#FFC700]">ready.</span></RevealLine>
        </h2>
        <p className="mt-6 max-w-lg text-base text-white/85 sm:text-lg">Sign up through my link, use code DAFABER and you're automatically in the $500 monthly leaderboard.</p>
        <div className="mt-10"><PlayButton size="lg" testId="final-play-roobet-button" /></div>
      </div>
    </section>
  );
};
